module.exports = __webpack_public_path__ + "img/tala.ffc51baf.png";